import { createSvgIcon } from "@mui/material";

const HomeIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#6C6F80" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 21V9L12 3L20 9V21H14V14H10V21H4Z"/>
  </svg>,
  'Home',
);
export default HomeIcon;
